export const GET_LIST_DATA = 'GET_LIST_DATA'
export const GET_LISTS_DATA = 'GET_LISTS_DATA'
export const CREATE_LIST = 'CREATE_LIST'
export const UPDATE_LIST = 'UPDATE_LIST'
export const DELETE_LIST = 'DELETE_LIST'
export const SET_LISTS_PROCESSING = 'SET_LIST_PROCESSING'
export const SET_LIST_DATA = 'SET_LIST_DATA'
export const UPDATE_LISTS_SUCCESS = 'UPDATE_LISTS_SUCCESS'
export const SET_LISTS_DATA = 'SET_LISTS_DATA'
export const SET_LISTS_ERROR = 'SET_LISTS_ERROR'
export const SET_NEW_LIST = 'SET_NEW_LIST'
export const SET_UPDATED_LIST = 'SET_UPDATED_LIST'

export function getList (payload) {
  return {
    type: GET_LIST_DATA,
    payload,
  }
}

export function setList (payload) {
  return {
    type: SET_LIST_DATA,
    payload,
  }
}

export function getListsData (payload) {
  return {
    type: GET_LISTS_DATA,
    payload,
  }
}

export function setNewList (payload) {
  return {
    type: SET_NEW_LIST,
    payload,
  }
}

export function setUpdatedList (payload) {
  return {
    type: SET_UPDATED_LIST,
    payload,
  }
}

export function setListsData (payload) {
  return {
    type: SET_LISTS_DATA,
    payload,
  }
}

export function createList (payload) {
  return {
    type: CREATE_LIST,
    payload,
  }
}

export function updateList (payload) {
  return {
    type: UPDATE_LIST,
    payload,
  }
}

export function deleteList (payload) {
  return {
    type: DELETE_LIST,
    payload,
  }
}

export function setListsDataProcessing (payload) {
  return {
    type: SET_LISTS_PROCESSING,
    payload,
  }
}

export function setListsDataError (payload) {
  return {
    type: SET_LISTS_ERROR,
    payload,
  }
}
